// Auto-generated normalizer for table: Cat_UnidadesOrg
export function tipoUndiadOrganizacionalNormalize(row) {
  const id =
    row.idTipoUnidadOrganizacional ??
    row.IdTipoUnidadOrganizacional ??
    row.idTipoUndiadOrganizacional ??
    row.IdTipoUndiadOrganizacional ??
    0;

  return {
    idTipoUnidadOrganizacional: id,
    idTipoUndiadOrganizacional: id, // Alias para compatibilidad
    clave: row.clave ?? row.Clave ?? row['Clave'] ?? '',
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? row['IdEmpresa'] ?? null,
    nombreEmpresa: row.nombreEmpresa ?? row.NombreEmpresa ?? row['NombreEmpresa'] ?? '',
    tieneEmpleados: !!(row.tieneEmpleados ?? row.TieneEmpleados ?? row['TieneEmpleados']),
    tieneUOs: !!(row.tieneUOs ?? row.TieneUOs ?? row['TieneUOs']),
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
